import {ThemeNames} from '../themes';
import {Theme} from '../interfaces/themes';
import {ChatRoomTypes, ProductNames} from '../constants';

export const benepsisConfig = {
  chatConfig: {
    theme: (ThemeNames.mk as Theme),
    productName: ProductNames.benepsis,
    chatExternalEvents: {
      chat_started: 'benepsis_chat_started',
      chat_connected: 'zchat_user_connected',
      chat_timeout: 'benepsis_polling_broken',
      chat_shown: 'benepsis_user_showed_chat',
      chat_hidden: 'benepsis_user_hidden_chat',
      click_link: 'benepsis_link_clicked',
      chat_closed: 'benepsis_chat_closed',
    }
  },
  roomConfig: {
    type: ChatRoomTypes.benepsisWebchat,
  }
};
